import React, { useState, useRef, useEffect } from 'react';

const SearchableSelect = ({
    options,
    value,
    onChange,
    placeholder = "Search...", className = "", selectClassName = ""
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");
    const dropdownRef = useRef(null);

    const selectedOption = options.find(opt => opt.value?.toString() === value?.toString());

    useEffect(() => {
        if (selectedOption) {
            setSearch(selectedOption.label);

        }
    }, [selectedOption]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) { setIsOpen(false); }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredOptions = options.filter(opt =>
        opt.label?.toLowerCase().includes(search.toLowerCase())
    );

    const handleSelect = (option) => {
        onChange(option.value); setSearch(option.label);
        setIsOpen(false);
    };

    return (

        <div className={`relative ${className}`} ref={dropdownRef}>
            <input type="text" value={search} placeholder={placeholder} onFocus={() => setIsOpen(true)} onChange={(e) => { setSearch(e.target.value); setIsOpen(true); }} className={`w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm ${selectClassName}`} />
            {isOpen && (<div className="absolute z-[99999] w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"> {filteredOptions.length > 0 ? (filteredOptions.map((option) => (<div key={option.value} onClick={() => handleSelect(option)} className="px-3 py-2 text-sm cursor-pointer hover:bg-blue-50 hover:text-blue-600 transition-colors" > {option.label} </div>))) : (<div className="px-3 py-2 text-xs text-gray-400 text-center"> No results found </div>)} </div>)} </div>);
};

export default SearchableSelect;

// import React, { useState, useRef, useEffect } from 'react';

// const SearchableSelect = ({ options, value, onChange, placeholder = "Select...", className = "", selectClassName = "" }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [search, setSearch] = useState("");
//     const dropdownRef = useRef(null);

//     const selectedOption = options.find(opt => opt.value === value || opt.value?.toString() === value?.toString());

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setIsOpen(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     // Filter options based on search query
//     const filteredOptions = options.filter(opt =>
//         opt.label?.toLowerCase().includes(search.toLowerCase())
//     );

//     const handleSelect = (val) => {
//         onChange(val);
//         setIsOpen(false);
//         setSearch("");
//     };

//     return (
//         <div className={`relative ${className}`} ref={dropdownRef}>
//             <button
//                 type="button"
//                 onClick={() => setIsOpen(!isOpen)}
//                 className={`w-full px-3 py-2 text-left bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm flex justify-between items-center ${selectClassName}`}
//             >
//                 <span className={selectedOption ? "text-gray-900 font-medium" : "text-gray-400"}>
//                     {selectedOption ? selectedOption.label : placeholder}
//                 </span>
//                 <svg
//                     className={`w-4 h-4 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                 >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                 </svg>
//             </button>

//             {isOpen && (
//                 <div className="absolute z-[99999] w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-hidden flex flex-col">
//                     <div className="p-2 border-b border-gray-100 bg-gray-50">
//                         <input
//                             type="text"
//                             value={search}
//                             onChange={(e) => setSearch(e.target.value)}
//                             placeholder="Search..."
//                             className="w-full px-3 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
//                             autoFocus
//                         />
//                     </div>
//                     <div className="overflow-y-auto flex-1 max-h-48">
//                         {filteredOptions.length > 0 ? (
//                             filteredOptions.map((opt) => (
//                                 <button
//                                     key={opt.value}
//                                     type="button"
//                                     onClick={() => handleSelect(opt.value)}
//                                     className={`w-full text-left px-3 py-2 text-sm hover:bg-blue-50 hover:text-blue-600 transition-colors flex items-center justify-between ${
//                                         (value === opt.value || value?.toString() === opt.value?.toString()) ? 'bg-blue-50 text-blue-600 font-semibold' : 'text-gray-700'
//                                     }`}
//                                 >
//                                     <span>{opt.label}</span>
//                                     {(value === opt.value || value?.toString() === opt.value?.toString()) && (
//                                         <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
//                                         </svg>
//                                     )}
//                                 </button>
//                             ))
//                         ) : (
//                             <div className="px-3 py-2 text-xs text-gray-400 text-center">No results found</div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default SearchableSelect;
